var React = require('react');

function IconPlayStoreInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.8053 21.0173L28.9514 13.8712L5.86984 0.89852C4.34009 0.0720199 2.907 -0.0439796 1.65034 0.859854L21.8053 21.0173ZM30.1694 29.3838L37.5983 25.2054C39.0483 24.3934 39.8433 23.243 39.8433 21.967C39.8433 20.6934 39.0483 19.5407 37.6007 18.7287L30.8751 14.9514L23.3037 22.5204L30.1694 29.3838ZM0.40817 2.61677C0.253504 3.09285 0.166504 3.62452 0.166504 4.20694V39.744C0.166504 40.6648 0.369504 41.4574 0.736837 42.0882L20.3046 22.518L0.40817 2.61677ZM21.8053 24.0164L2.34634 43.4778C2.7185 43.6204 3.11967 43.6953 3.54259 43.6953C4.29659 43.6953 5.082 43.4729 5.88192 43.0283L28.2482 30.4689L21.8053 24.0164Z","fill":"white"}));
}

IconPlayStoreInline.defaultProps = {"width":"40","height":"44","viewBox":"0 0 40 44","fill":"none"};

module.exports = IconPlayStoreInline;

IconPlayStoreInline.default = IconPlayStoreInline;
